export const paths = {
  app: {
    index: '/',
  },
  issues: {
    index: 'issues',
    manage: 'manage',
    create: 'issues/create',
    master: 'master-issues',
    relationships: 'relationships',
  },
  settings: {
    index: 'settings',
  },
  issueTypes: {
    index: 'issue-types',
    add: 'add-sub-type',
    edit: 'edit',
  },
  issueTemplates: {
    index: 'templates',
    add: 'add',
    edit: (slug: string) => `${slug}`,
  },
  slaConfiguration: {
    index: 'slas',
  },
  error: 'error',
  entitlementError: 'entitlement-error',
  attachments: 'attachments',
};
